module.exports = __webpack_public_path__ + "img/27.18cfbb8f.svg";